import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import { putStravaLink } from './StravaClient';

import Error from 'Components/Form/Error';
import StravaActivity from './StravaActivity';
import Navigation from 'Components/Page/Navigation';

function StravaCallback () 
{
    const location = useLocation  ();
    const navigate = useNavigate ();

    const { currentUser, reloadCustomAttributes } = useContext ( CurrentUserContext );
    
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );
    const [ response, setResponse ] = useState ( null );
    const [ activities, setActivities ] = useState ( [] );

    useEffect ( () => {

        if ( isLoading === false && response === null )
        {
            const queryParams = new URLSearchParams ( location.search );

            if ( queryParams.get ( 'error' ) )
            {
                setIsLoading ( false );
                setResponse ( false );
                setError ( { isError: true, message: "Strava link was unsuccesful: '" + queryParams.get ( 'error' ) + "'" } );
            }
            else if ( queryParams.get ( 'scope' ) !== "read,activity:read_all" )
            {
                setIsLoading ( false );
                setResponse ( false );
                setError ( { isError: true, message: "This app requires permission to read private activities from Strava in order to add your KMs to the leaderboards. If you try again, please leave the 'View data about your private activities' checked. If you do not want to enable this, please do not link your Strava account. Instead you can manually log your kilometers using the 'Add KM' button below." } );   
            }
            else
            {
                setIsLoading ( true );

                putStravaLink ( currentUser, queryParams.get ( 'state' ), queryParams.get ( 'code' ), queryParams.get ( 'scope' ) )
                    .then ( response => {
                        setResponse ( response.data.message );
                        setActivities ( response.data.activities );
                        setIsLoading ( false );
                        setError ( { isError: false, message: null } );                
                        reloadCustomAttributes ();
                    } )
                    .catch ( error => {
                        if ( !response )
                        {
                            setResponse ( error );
                            setIsLoading ( false );
                            setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                        }
                    } );
            }
        }
    }, [ isLoading, response ] );

    let activitiesDisplay = null;

    if ( response !== null && response !== false )
    {
        if ( activities?.length > 0 )
        {
            activitiesDisplay = <>
                                    <h2>We've added your eligible activities!</h2>
                                    <ul>{ activities.map ( ( activity, index ) => <StravaActivity key={"activity-" + index} activity={activity} /> ) }</ul>
                                    <p className="p-2 my-4 font-bold bg-pgorange text-pgwhite rounded-lg">
                                        Any other activities you log in Strava during the event will automatically add to your team's leaderboards!
                                    </p>
                                    <Navigation />
                                </>
        }
        else
        {
            activitiesDisplay = <>
                                    <p>You have no activities yet, but anything logged in Strava will automatically add to your team's leaderboards.</p>
                                    <Navigation />
                                </>;
        }
    }

    return  <>
                <h1>Finalising Strava Link</h1>
                { error.isError && <Error message={error.message} /> }
                { response === null && <p className="pb-8">Waiting for response...</p> }
                {activitiesDisplay}
                { error.isError && <button onClick={ () => navigate ( "/participant/secure/strava" ) } >Try Strava Link Again</button> }
                
            </>
}

export default StravaCallback;
